<template>
    <div>
        <ValidationObserver tag="form" ref="observer" @submit.prevent="onSubmit">
            <FormLesiones :form="form"/>

            <b-button :disabled="isAdd" type="submit">Crear</b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    import FormLesiones from './FormLesiones.vue';

    export default {
        props: [
            'base_id',
            'lesiones'
        ],
        data() {
            return {
                form: {
                    fecha_baja: null,
                    orientacion_diagnostica: '',
                    fecha_alta: null,
                },
                isAdd: false,
            }
        },
        methods: {
            async onSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.isAdd = true;
                    this.form.filters = {};
                    this.form.base_id = this.base_id;
                    this.form.lista_id = this.lista_id;

                    this.$store.dispatch(this.config.getVuexAlias('back.bases.lesiones.create'), this.form).then(() => {
                        this.$toast.success('Lesión creada correctamente.');
                        this.isAdd = false;
                        this.$emit('crearLesion');
                    }).catch(e => {
                        this.$toast.error('An error occurred');
                        this.isAdd = false;
                    });
                }

            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            FormLesiones
        }
    }
</script>